"use strict";
// names from http://chir.ag/projects/name-that-color/
Object.defineProperty(exports, "__esModule", { value: true });
var Solid = {
    primaryBlue: "#2793FF",
    primaryGreen: "#0AC18E",
    primaryYellow: "#FFBE3D",
    primaryRed: "#FF5050",
    secondaryOne: "#F7FAFD",
    secondaryTwo: "#F6FBFB",
    secondaryThree: "#FBF9F5",
    secondaryFour: "#FBF5F6",
    textOne: "#2D323B",
    textTwo: "#5B667C",
    textThree: "#8A94A6",
    textFour: "#B0B7C3",
    bgGrey: "#F1F7FD",
    bgWhite: "#FFFFFF",
    white: "#FFFFFF",
    caribbeanGreen: "#0AC18E",
    caribbeanGreenDarkest: "",
    caribbeanGreenDark: "",
    caribbeanGreenLight: "",
    caribbeanGreenLightest: "",
    vulcan: "#131720",
    vulcanLight: "#111724",
    vulcanLightest: "#6B717E",
    java: "#18E2C1",
    alto: "#D8D8D8",
    ghost: "#C7CDD9",
    ghostLight: "#C8CDD8",
    bunker: "#0D1017",
    mystic: "#E5E8F0",
    comet: "#49505F",
    cometDark: "#2D323B",
    cometDarkest: "#272B34",
    zircon: "#FBFCFF",
    zirconDark: "#FDFDFD",
    zirconDarkest: "#CDCDCD",
    pictonBlue: "#2FA9EE",
    royalBlue: "#6C43EE",
    governorBay: "#2933BC",
    gamboge: "#F09E0E",
    fuelYellow: "#EDB72E",
    cinnabar: "#E23F2E",
    violetRed: "#EE3772"
};
var Fill = {
    solid: "url(https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/fill.png)",
    gradient: "url(https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/btn.png)",
    gradientLight: "url(https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/btn_h.png)",
    gradientDark: "url(https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/btn_a.png)"
};
var Gradient = {
    caribbeanGreen: "linear-gradient(#2FA9EE, #31C275)",
    pictonBlue: "linear-gradient(#4AB8FA, #1499E2)",
    royalBlue: "linear-gradient(#8256FF, #562FDE)",
    governorBay: "linear-gradient(#2C40C9, #2625B0)",
    gamboge: "linear-gradient(#F6A414, #EA9808)",
    fuelYellow: "linear-gradient(#FFCB57, #DBA204)",
    cinnabar: "linear-gradient(#EB4B37, #D93324)",
    violetRed: "linear-gradient(#FF3F92, #DE2F51)"
};
exports.colors = { solid: Solid, gradient: Gradient, fill: Fill };
//# sourceMappingURL=colors.js.map